import { createContext } from 'react';

export const SynchronizationStatusContext =
  createContext<SynchronizationStatusContextValue>({
    itemsToSynchronizeInfos: [],
    inProgress: false
  });

export type SynchronizationStatusContextValue = {
  itemsToSynchronizeInfos: Array<ItemToSynchronizeInfo>;
  inProgress: boolean;
};

export type ItemToSynchronizeInfo = {
  id: string | number;
  failed: boolean;
  entityName: string;
};
